import React from 'react';
import { DownloadIcon, GlobeIcon, InfinityIcon, MonitorSmartphoneIcon, RefreshCwIcon, WalletIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const VALUE_ROWS = [{
  label: 'Sistema Maestro de TRT™',
  value: 'USD 197'
}, {
  label: 'Pack de Algoritmos Clínicos',
  value: 'USD 49'
}, {
  label: 'Biblioteca de Casos Clínicos',
  value: 'USD 97'
}, {
  label: 'Kit Profesional para la Consulta',
  value: 'USD 67'
}, {
  label: 'Calculadora Clínica',
  value: 'USD 79'
}, {
  label: 'Guía de Complicaciones',
  value: 'USD 57'
}];
const INCLUDES = [{
  Icon: ZapIcon,
  text: 'Acceso inmediato'
}, {
  Icon: DownloadIcon,
  text: 'Descarga digital'
}, {
  Icon: RefreshCwIcon,
  text: 'Actualizaciones futuras incluidas'
}, {
  Icon: MonitorSmartphoneIcon,
  text: 'Computadora, tablet y celular'
}, {
  Icon: InfinityIcon,
  text: 'Acceso de por vida'
}, {
  Icon: WalletIcon,
  text: 'Pago único'
}];
export function Offer() {
  return <section className="w-full bg-cream-100 py-12 sm:py-16" aria-labelledby="offer-title" id="oferta" data-id="element-144" data-mp="pjyz5iqcevsz">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-145" data-mp="zies7r8xkf54">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-146" data-mp="ziwo2mrokrci">
          Su oferta de hoy
        </p>
        <h2 id="offer-title" className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-147" data-mp="6tpqpr3yq7su">
          Todo este sistema tiene un valor estimado de USD 546
        </h2>

        <div className="mt-7 overflow-hidden rounded-3xl border border-navy-900/10 bg-white shadow-[0_18px_45px_-30px_rgba(11,32,56,0.6)]" data-id="element-148" data-mp="ftcsie0ltfmf">
          <div className="flex items-center justify-between bg-navy-900 px-4 py-3" data-id="element-149" data-mp="kn8ojaxb4sey">
            <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-cream-100/80" data-id="element-150" data-mp="3k8dmwz0ysrps">
              Incluye
            </span>
            <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-gold-400" data-id="element-151" data-mp="vfh4q7ui0tjc">
              Valor
            </span>
          </div>
          <ul data-id="element-152" data-mp="qg4j1qfd5sic">
            {VALUE_ROWS.map(row => <li key={row.label} className="flex items-start justify-between gap-3 border-b border-navy-900/10 px-4 py-3" data-id="element-153" data-mp="15620zomp9lz3">
                <span className="text-[13.5px] font-medium leading-snug text-navy-800 sm:text-[15px]" data-id="element-154" data-mp="108th9jlwl9vq">
                  {row.label}
                </span>
                <span className="shrink-0 text-[13.5px] font-bold text-navy-800/60 line-through sm:text-[15px]" data-id="element-155" data-mp="7j3cw2a2pmct">
                  {row.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-3 bg-cream-100 px-4 py-3.5" data-id="element-156" data-mp="hewpflnslful">
              <span className="text-[13.5px] font-extrabold uppercase tracking-wide text-navy-900 sm:text-[15px]" data-id="element-157" data-mp="1wvopwsvmfytg">
                Valor total
              </span>
              <span className="font-display text-xl font-bold text-navy-900" data-id="element-158" data-mp="20ex8s33r7vv3">USD 546</span>
            </li>
          </ul>
        </div>

        <div className="mt-6 rounded-3xl bg-navy-950 p-5 text-center sm:p-7" data-id="element-159" data-mp="25erxc00249cz">
          <p className="text-[14px] leading-relaxed text-cream-100/80 sm:text-base" data-id="element-160" data-mp="1qgzjdca5rt0w">
            Pero hoy no pagará USD 546. Ni USD 197. Ni siquiera USD 97.
          </p>
          <p className="mt-4 text-[12px] font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-161" data-mp="1vhdskxnhx90i">
            Hoy puede acceder por solo
          </p>
          <p className="mt-1 font-display text-[52px] font-bold leading-none text-white sm:text-6xl" data-id="element-162" data-mp="2o36pwrq0vvfw">
            USD 15
          </p>
          <p className="mt-2 text-[13px] font-medium text-cream-100/70 sm:text-sm" data-id="element-163" data-mp="29d99ixyc4a19">
            Menos de lo que cuesta una comida — y probablemente el recurso clínico que más
            usará en los próximos años.
          </p>

          <div className="mt-4 flex items-start justify-center gap-2 rounded-2xl border border-white/10 bg-white/5 p-3 text-left" data-id="element-164" data-mp="36ug1d6jcsua4">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-165" data-mp="1j7fporggrjg0" />
            <p className="text-[12.5px] font-medium leading-snug text-cream-100/85" data-id="element-166" data-mp="1e69xcuqpty70">
              <strong className="font-bold text-white" data-id="element-167" data-mp="197ozh1yxrqlq">Cambio de moneda automático:</strong>{' '}
              el checkout detecta su país y convierte el precio a su moneda local. No debe
              calcular nada.
            </p>
          </div>

          <div className="mt-5 flex flex-col items-center gap-5" data-id="element-168" data-mp="21w4cxk2f60uy">
            <ScarcityBar data-id="element-169" data-mp="1wyucl9dhs4sc" />
            <CtaButton label="Quiero el Sistema por USD 15" subLabel="Pago único · Acceso inmediato · Garantía incondicional de 7 días" data-id="element-170" data-mp="1wykv6a6ij5y9" />
            <Countdown label="Este precio se cierra en" data-id="element-171" data-mp="1n783bikpsfs8" />
          </div>
        </div>

        <div className="mt-6 rounded-3xl border border-navy-900/10 bg-white p-4 sm:p-5" data-id="element-172" data-mp="2kof80rqu0uii">
          <p className="text-center text-[12px] font-bold uppercase tracking-[0.14em] text-navy-800/60" data-id="element-173" data-mp="2fwf12fcch1cf">
            Su compra incluye
          </p>
          <ul className="mt-3.5 grid grid-cols-1 gap-2.5 sm:grid-cols-2" data-id="element-174" data-mp="2o7e1oglquofi">
            {INCLUDES.map(item => <li key={item.text} className="flex items-start gap-2.5" data-id="element-175" data-mp="2s8pqwl0ph7n6">
                <item.Icon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-176" data-mp="2x4obdxiwy5ib" />
                <span className="text-[13.5px] font-medium leading-snug text-navy-800" data-id="element-177" data-mp="374p05yzjxdtw">
                  {item.text}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}